/**
 * GameResultModal styles — collectible card design.
 */

import { StyleSheet, Platform } from 'react-native';

interface Insets {
  top: number;
  bottom: number;
}

export const getGameResultModalStyles = (insets: Insets) => {

  const webModalRoot =
    Platform.OS === 'web'
      ? ({
          position: 'fixed' as never,
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 10000,
        } as const)
      : {};

  const bottomContentPadding = insets.bottom + (Platform.OS === 'web' ? 20 : 32);

  return StyleSheet.create({
    overlayPressable: {
      ...StyleSheet.absoluteFillObject,
      flex: 1,
      ...webModalRoot,
    },
    blurBg: {
      ...StyleSheet.absoluteFillObject,
    },
    overlayBg: {
      ...StyleSheet.absoluteFillObject,
      backgroundColor: 'rgba(5,3,15,0.96)',
    },
    contentWrap: {
      ...StyleSheet.absoluteFillObject,
      flexDirection: 'column',
      paddingTop: insets.top + 12,
      paddingBottom: bottomContentPadding,
    },
    bottomSection: {
      justifyContent: 'flex-end',
      alignItems: 'center',
      paddingTop: 8,
      paddingHorizontal: 24,
      flexShrink: 0,
    },
    ctaPressable: {
      paddingVertical: 14,
      paddingHorizontal: 32,
      ...(Platform.OS === 'web' && { cursor: 'pointer' as const }),
    },
    ctaPressablePressed: {
      opacity: 0.75,
    },
    ctaPressableHover: {
      ...(Platform.OS === 'web' && { opacity: 0.88 }),
    },
    ctaText: {
      fontSize: 13,
      fontWeight: '700',
      letterSpacing: 2,
      textTransform: 'uppercase',
      color: 'rgba(255,255,255,0.55)',
    },
    overflowHint: {
      fontSize: 12,
      fontWeight: '500',
      color: 'rgba(255,255,255,0.40)',
      textAlign: 'center' as const,
      marginBottom: 6,
      letterSpacing: 0.3,
    },
    desktopArrowsRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 24,
      marginBottom: 10,
    },
    desktopArrowButton: {
      width: 40,
      height: 40,
      borderRadius: 20,
      borderWidth: 1,
      borderColor: 'rgba(255,255,255,0.22)',
      backgroundColor: 'rgba(255,255,255,0.07)',
      alignItems: 'center',
      justifyContent: 'center',
      ...(Platform.OS === 'web' && { cursor: 'pointer' as const }),
    },
    desktopArrowButtonPressed: {
      opacity: 0.75,
    },
    desktopArrowButtonHover: {
      ...(Platform.OS === 'web' && { opacity: 0.9 }),
    },
    desktopArrowButtonDisabled: {
      opacity: 0.30,
    },
    dotsRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 6,
      marginBottom: 8,
    },
    dot: {
      width: 6,
      height: 6,
      borderRadius: 3,
    },
    dotActive: {
      backgroundColor: 'rgba(255,255,255,0.90)',
    },
    dotInactive: {
      backgroundColor: 'rgba(255,255,255,0.25)',
    },
  });
};

export function getGameResultModalLayoutStyles(screenWidth: number) {
  return StyleSheet.create({
    slide: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
    slideFlex: {
      flex: 1,
    },
    slideScreenWidth: {
      width: screenWidth,
    },
    contentList: {
      flex: 1,
      width: screenWidth,
    },
    contentListContent: {
      flexGrow: 1,
    },
  });
}
